<template>
  <v-flex class="mt-0 mx-2">
    <v-dialog v-model="dialogFormularioReserva" :width="dialogWidth" persistent>
      <reserva-formulario-movil
        :modelReserva="this.modelReserva"
        :accion="this.accion"
        @cerrarFormularioReserva="_actualizarDatos"
        @actualizar="_actualizar"
        @cerrar="dialogFormularioReserva = false"
      />
    </v-dialog>

    <v-dialog v-model="showLoading" width="300px" persistent>
      <v-card
        class="mx-auto"
        outlined
        :color="colorFondo300"
        :style="'border: 1px solid grey;'"
      >
        <v-card-text>
          <v-row justify="center" class="mt-12">
            <span v-bind:style="{ color: 'grey' }"> Cargando datos... </span>
          </v-row>

          <v-row justify="center" class="mt-8 mb-2">
            <v-spacer />
            <v-row>
              <v-col>
                <v-progress-linear
                  :color="colorEBikeAccent1"
                  indeterminate
                  rounded
                  height="6"
                  width="100px"
                ></v-progress-linear>
              </v-col>
            </v-row>
            <v-spacer />
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row>
      <v-card class="mt-0 mb-2 pt-2 pb-0" outlined :color="'white'">
        <div class="table-style">
          <table class="table table-sm mx-0">
            <caption></caption>
            <tr>
              <th
                id="dias_del_mes"
                class="font-weight-bolder text-uppercase"
                v-bind:style="{ color: colorFront200 }"
              ></th>
              <th
                id="dias"
                class="text-center"
                v-for="day in arrayFechas"
                v-bind:key="day"
                v-bind:style="{
                  color: 'black',
                  'background-color': _colorIsWeekendHeader(day),
                }"
              >
                {{ _inicialDiaSemana(day) }}
              </th>
            </tr>
            <tr>
              <th
                id="dias_del_mes"
                class="font-weight-bolder text-uppercase"
                v-bind:style="{ color: colorFront200 }"
              ></th>
              <th
                id="dias"
                class="text-center"
                v-for="day in arrayFechas"
                v-bind:key="day"
                v-bind:style="{
                  color: 'black',
                  'background-color': _colorIsWeekendHeader(day),
                }"
              >
                {{ day.substring(5, 7) }}
              </th>
            </tr>
            <tr>
              <th
                id="dias"
                class="font-weight-bolder text-uppercase"
                v-bind:style="{ width: '150px' }"
              >
                <!-- <v-menu
                :dark="dark"
                v-model="showdate"
                offset-y
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="mr-2"
                    :dark="dark"
                    clearable
                    dense
                    outlined
                    :value="_captionMonthSelec"
                    label="Seleccione el mes"
                    readonly
                    v-on="on"
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  :dark="dark"
                  locale="es"
                  v-model="monthSelec"
                  @input="showdate = false"
                  type="month"
                  color="blue lighten-1"
                  header-color="success"
                  @change="_getReservasCalendario(true)"
                ></v-date-picker>
              </v-menu> -->
              </th>

              <th
                id="dias"
                class="text-center"
                v-for="day in arrayFechas"
                v-bind:key="day"
                v-bind:style="{
                  color: 'black',
                  'background-color': _colorIsWeekendHeader(day),
                }"
              >
                {{ day.substring(8, 10) }}
              </th>
            </tr>
            <tr v-for="bici in bicis" :key="bici.id">
              <th
                id=""
                class="px-6 text-uppercase font-weight-bolder"
                v-text="_captionNombreBici(bici)"
                v-bind:style="{ color: 'black' }"
                style="text-align: right"
              ></th>
              <td
                class="px-1 pb-1"
                v-for="day in arrayFechas"
                :key="day"
                v-bind:style="{
                  'background-color': _colorFondoCelda(day, bici),
                }"
              >
                <v-chip
                  class="px-1"
                  :color="_showStatusItem(bici, day)"
                  style="width: 50px"
                  label
                  link
                  small
                  @click="_mostrarDetalleReserva(day, bici)"
                  @contextmenu="_remarcarReserva(day, bici, true)"
                >
                <span v-if="_esInicioDeReserva(day, bici)"  v-bind:style="{ color: _colorInicioFinal(day, bici), fontSize: '20px' }">
                    &#9654;
                  </span>
                  <span v-bind:style="{ color: _colorTextoCelda(bici, day) }">
                    {{ bici.talla + bici.numero }}
                  </span>
                  <span v-if="_esFinalDeReserva(day, bici)"  v-bind:style="{ color: _colorInicioFinal(day, bici), fontSize: '20px' }">
                    &#9664;
                  </span>
                </v-chip>
              </td>
            </tr>
          </table>
        </div>
      </v-card>
    </v-row>
    <v-row justify="center">
      <v-chip
        class="pl-3 mt-1"
        :color="'blue'"
        style="width: 50px"
        label
        link
        larque
        @click="irAtras()"
      >
        <v-icon color="white">mdi-chevron-double-left</v-icon>
      </v-chip>

      <v-spacer />

      <v-menu
        :dark="dark"
        v-model="showdate"
        offset-y
        :close-on-content-click="false"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            style="width: 200px"
            class="mr-2 shrink"
            dark
            dense
            outlined
            :value="_captionMonthSelec"
            label="Buscar un mes"
            readonly
            v-on="on"
            hide-details
            :background-color="colorEBikeAccent1"
          ></v-text-field>
        </template>
        <v-date-picker
          :dark="dark"
          locale="es"
          v-model="monthSelec"
          @input="showdate = false"
          type="month"
          color="blue lighten-1"
          header-color="success"
          @change="getReservasCalendarioPorMes()"
        ></v-date-picker>
      </v-menu>

      <!-- <v-chip
        class="mb-4 px-10"
        style="width: 200px; height: 40px"
        :color="'green'"
        @click="_cerrarSesion"
      >
        <h5 class="ml-5" v-bind:style="{ color: 'white' }">CERRAR SESIÓN</h5>
      </v-chip>  -->

      <v-spacer />

      <v-chip
        class="pl-3 mt-1"
        :color="'blue'"
        style="width: 50px"
        label
        link
        larque
        @click="irAdelante()"
      >
        <v-icon color="white">mdi-chevron-double-right</v-icon>
      </v-chip>
    </v-row>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ReservaFormularioMovil from "../components/formularios/ReservaFormularioMovil.vue";

export default {
  name: "Anual",

  components: {
    ReservaFormularioMovil,
  },

  data: () => ({
    showdate: false,
    showLoading: true,
    showDetalleReserva: false,
    monthNames: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],

    modelReserva: null,
    dialogFormularioReserva: false,
    accion: "",
    monthSelec: new Date().toISOString().substr(0, 7),
    reservaRemarcada: null,
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",
      "colorEBikeAccent1",

      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("reservas", [
      "reservasCalendario",
      "tallerCalendario",
      "reservaSelec",
      "dialogWidth",
      "from",
      "until",
    ]),

    ...mapState("bicis", ["bicis"]),

    cantDias() {
      let m = this._captionMonthSelec;
      switch (m) {
        case "Febrero":
          return 28;
          break;
        case "Enero":
        case "Marzo":
        case "Mayo":
        case "Julio":
        case "Agosto":
        case "Octubre":
        case "Diciembre":
          return 31;
          break;
        default:
          return 30;
          break;
      }
    },

    month() {
      return this.monthSelec.substring(5, 7);
    },

    _captionMonthSelec() {
      return this.monthNames[parseInt(this.month) - 1];
    },

    arrayFechas() {
      var res = [];
      for (
        var d = new Date(this.from);
        d <= new Date(this.until);
        d.setDate(d.getDate() + 1)
      ) {
        res.push(new Date(d).toISOString().substring(0, 10));
      }

      return res;
    },
  },

  mounted() {
    if (!this.user) {
      this.$router.push("/login");
    }
    let hoy = new Date();
    let ayer = new Date(Date.now() - 2 * 24 * 60 * 60 * 1000);

    hoy.setHours(0, 0, 0, 0);
    this.setFrom(new Date(hoy));
    this.setUntil(new Date(Date.now() + 31 * 24 * 60 * 60 * 1000));
    this._getReservasCalendario(ayer, this.until, true);
  },

  methods: {
    ...mapActions("reservas", ["getReservasCalendario"]),
    ...mapMutations("reservas", ["setReservaSelec", "setFrom", "setUntil"]),

    getReservasCalendarioPorMes() {
      this.setFrom(new Date(Date.parse(this.monthSelec + "-01")));
      this.setUntil(
        new Date(Date.parse(this.monthSelec + "-" + this.cantDias))
      );

      this._getReservasCalendario(this.from, this.until, true);
    },

    _cerrarSesion() {
      this.$router.push("/login");
    },

    _captionNombreBici(bici) {
      return bici.marca.substr(0, 1); // + " " + bici.talla + "-" + bici.numero;
    },

    _actualizarDatos() {
      this.dialogFormularioReserva = false;
      this._getReservasCalendario(this.from, this.until, true);
    },

    _actualizar() {
      this._getReservasCalendario(this.from, this.until, false);
    },

    _remarcarReserva(day, bici, remarcar) {
      if (!remarcar) {
        this.reservaRemarcada = null;
      } else {
        let fecha = day;

        let reservasConfirmadas = this.reservasCalendario.filter(
          (e) => e.estado.nombre == "CONFIRMADA"
        );

        for (let index = 0; index < reservasConfirmadas.length; index++) {
          const res = reservasConfirmadas[index];
          if (
            this._biciEnReserva(res, bici) &&
            res.fecha_bloqueo <= fecha &&
            res.fecha_final >= fecha
          ) {
            this.reservaRemarcada = res;
            return res;
          }
        }

        let reservasPresupuestadas = this.reservasCalendario.filter(
          (e) => e.estado.nombre == "PRESUPUESTADA"
        );

        for (let index = 0; index < reservasPresupuestadas.length; index++) {
          const res = reservasPresupuestadas[index];
          if (
            this._biciEnReserva(res, bici) &&
            res.fecha_bloqueo <= fecha &&
            res.fecha_final >= fecha
          ) {
            this.reservaRemarcada = res;
            return res;
          }
        }

        this.reservaRemarcada = null;
      }
    },

    _getFechaCompleta(day) {
      var dcero = day;
      if (day < 10) {
        dcero = "0" + day;
      }
      return new Date(this.monthSelec + "-" + dcero)
        .toISOString()
        .substring(0, 10);
    },

    _mostrarDetalleReserva(fecha, bici) {
      let reserva = null;

      let reservasConfirmadas = this.reservasCalendario.filter(
          (e) => e.estado.nombre == "CONFIRMADA"
        );

      for (let index = 0; index < reservasConfirmadas.length; index++) {
        const res = reservasConfirmadas[index];
        if (
          this._biciEnReserva(res, bici) &&
          res.fecha_bloqueo <= fecha &&
          res.fecha_final >= fecha
        ) {
          reserva = res;
          break;
        }
      }

      if (reserva == null){
        let reservasPresupuestadas = this.reservasCalendario.filter(
          (e) => e.estado.nombre == "PRESUPUESTADA"
        );

        for (let index = 0; index < reservasPresupuestadas.length; index++) {
        const res = reservasPresupuestadas[index];
        if (
          this._biciEnReserva(res, bici) &&
          res.fecha_bloqueo <= fecha &&
          res.fecha_final >= fecha
        ) {
          reserva = res;
          break;
        }
      }


      }





      if (reserva) {
        this.setReservaSelec(reserva);
        let temp = JSON.parse(JSON.stringify(this.reservaSelec));
        this.modelReserva = temp;
        this.accion = "editar";
        console.log('reserva:', this.modelReserva);
        this.dialogFormularioReserva = true;
      }
    },

    _showStatusItem(bici, day) {
      if (this._estaEnTaller(day, bici)) return "red lighten-4";
      let color = this._estaEnReserva(day, bici);
      if (color != null) return color;
      return "white";
    },

    _biciEnReserva(res, bici) {
      for (let index = 0; index < res.bicis.length; index++) {
        const b = res.bicis[index];
        if (b.id == bici.id) return true;
      }
      return false;
    },

    _estaEnTaller(fecha, bici) {
      for (let index = 0; index < this.tallerCalendario.length; index++) {
        const res = this.tallerCalendario[index];
        if (
          res.bici_id == bici.id &&
          res.fecha_inicial <= fecha &&
          res.fecha_final >= fecha
        ) {
          return true;
        }
      }
      return false;
    },

    _esInicioDeReserva(day, bici) {
      for (let index = 0; index < this.reservasCalendario.length; index++) {
        const res = this.reservasCalendario[index];
        if (
          this._biciEnReserva(res, bici) &&
          res.fecha_bloqueo == day 
        ) {
          return true;
        }
      }
      return false;
    },

    _esFinalDeReserva(day, bici) {
      for (let index = 0; index < this.reservasCalendario.length; index++) {
        const res = this.reservasCalendario[index];
        if (
          this._biciEnReserva(res, bici) &&
          res.fecha_final == day 
        ) {
          return true;
        }
      }
      return false;
    },

    _colorInicioFinal(day, bici){
      let res = this._getReservaFromBici(day, bici);
      if (res != null && res.estado.nombre == "CONFIRMADA") {
        return "red";
      }
      return 'blue';
    },

    _estaEnReserva(fecha, bici) {
      let reservasPresupuestadas = this.reservasCalendario.filter(
        (e) => e.estado.nombre == "PRESUPUESTADA"
      );
      let result = null;
      for (let index = 0; index < reservasPresupuestadas.length; index++) {
        const res = reservasPresupuestadas[index];
        if (
          this._biciEnReserva(res, bici) &&
          res.fecha_bloqueo <= fecha &&
          res.fecha_final >= fecha
        ) {
          result = res.estado.color;
        }
      }

      let reservasOtras = this.reservasCalendario.filter(
        (e) => e.estado.nombre != "PRESUPUESTADA"
      );

      for (let index = 0; index < reservasOtras.length; index++) {
        const res = reservasOtras[index];
        if (
          this._biciEnReserva(res, bici) &&
          res.fecha_bloqueo <= fecha &&
          res.fecha_final >= fecha
        ) {
          if (res.fecha_bloqueo <= fecha && fecha < res.fecha_inicial) {
            result = "#8fc292"; //verde clarito
          } else {
            result = res.estado.color;
          } //verde oscuro
        }
      }
      return result;
    },

    _getReservaFromBici(fecha, bici) {
      let reservasPresupuestadas = this.reservasCalendario.filter(
        (e) => e.estado.nombre == "CONFIRMADA"
      );

      for (let index = 0; index < reservasPresupuestadas.length; index++) {
        const res = reservasPresupuestadas[index];
        if (
          this._biciEnReserva(res, bici) &&
          res.fecha_inicial <= fecha &&
          res.fecha_final >= fecha
        ) {
          return res;
        }
      }

      for (let index = 0; index < this.reservasCalendario.length; index++) {
        const res = this.reservasCalendario[index];
        if (
          this._biciEnReserva(res, bici) &&
          res.fecha_inicial <= fecha &&
          res.fecha_final >= fecha
        ) {
          return res;
        }
      }
      return null;
    },

    _getColorFondoOfReserva(fecha, bici) {
      for (let index = 0; index < this.reservasCalendario.length; index++) {
        const res = this.reservasCalendario[index];
        if (
          this._biciEnReserva(res, bici) &&
          res.fecha_inicial <= fecha &&
          res.fecha_final >= fecha
        ) {
          return res.color;
        }
      }
      return null;
    },

    _colorIsWeekendHeader(day) {
      var today = new Date().toISOString().substr(0, 10);
      if (day == today) {
        return "#90CAF9"; //azul clarito
      }

      if (this._isWeekend(day)) {
        return "rgb(180, 180, 180)";
      } else {
        return "rgb(230, 230, 230)";
      }
    },

    _colorFondoCelda(day, bici) {
      if (this._estaEnTaller(day, bici)) return "#F44336"; //rojo

      if (this.reservaRemarcada != null) {
        let fecha = day;
        if (
          this._biciEnReserva(this.reservaRemarcada, bici) &&
          this.reservaRemarcada.fecha_bloqueo <= fecha &&
          this.reservaRemarcada.fecha_final >= fecha
        ) {
          return "#2196F3"; //AZUL
        }
      }
      return "rgb(230, 230, 230)";
    },

    _colorTextoCelda(bici, day) {
      let res = this._getReservaFromBici(day, bici);
      if (res != null && res.estado.nombre == "CONFIRMADA") {
        return "white";
      }
      return "grey";
    },

    _inicialDiaSemana(day) {
      let days = ["D", "L", "M", "X", "J", "V", "S"];
      let d = new Date(day);
      let dd = d.getUTCDay();
      return days[dd];
    },

    _isWeekend(fecha) {
      return (
        new Date(fecha).getUTCDay() == 0 || new Date(fecha).getUTCDay() == 6
      );
    },

    async _getReservasCalendario(from, until, loading) {
      if (loading) {
        this.showLoading = true;
      }
      await this.getReservasCalendario([
        this.access_token,
        from,
        until,
        loading,
      ]);
      this.showLoading = false;
    },

    /* loadMoreData({ target: { scrollLeft, clientWidth, scrollWidth } }) {
      if (scrollLeft + clientWidth >= scrollWidth) {
        this.setUntil(
          new Date(Date.parse(this.until) + 30 * 24 * 60 * 60 * 1000)
        );
        this._getReservasCalendario(this.from, this.until, true);
      }
    },*/

    irAtras() {
      this.setFrom(new Date(Date.parse(this.from) - 30 * 24 * 60 * 60 * 1000));
      this._getReservasCalendario(
        Date.parse(this.from) - 2 * 24 * 60 * 60 * 1000,
        this.until,
        true
      );
    },

    irAdelante() {
      this.setUntil(
        new Date(Date.parse(this.until) + 30 * 24 * 60 * 60 * 1000)
      );
      this._getReservasCalendario(
        Date.parse(this.from) - 2 * 24 * 60 * 60 * 1000,
        this.until,
        true
      );
    },
  },
};
</script>

<style type="text/css">
.table-style {
  overflow-x: auto;
}
.table-style tr th:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
  background-color: white;
}
</style>
